module.exports = __webpack_public_path__ + "static/img/poster-bac2.b178b364.png";